/* eslint-disable no-unused-vars */

// ---------------------------------------
// Main.js
// ---------------------------------------

import axios from 'axios'

import Vue from 'vue'
import JScrollSrc from 'nova-tn-frontend/source/scripts/libraries/jscroll-src'
import Anka from 'nova-tn-frontend/source/scripts/libraries/anka'
// var Klebetnica = require('nova-tn-frontend/source/scripts/libraries/klebetnica');
// var Channel = require('nova-tn-frontend/source/scripts/libraries/channel');
// var Gemius = require('nova-tn-frontend/source/scripts/libraries/gemius');

import '../scripts/services/players'

// ---------------------------------------
// Internal modules
// ---------------------------------------

import Navigation from 'nova-tn-frontend/source/scripts/modules/Navigation'
import Stickies from 'nova-tn-frontend/source/scripts/modules/Stickies'
import JScroll from 'nova-tn-frontend/source/scripts/modules/JScroll'
import Search from 'nova-tn-frontend/source/scripts/modules/Search'
import Share from 'nova-tn-frontend/source/scripts/modules/Share'
// import Miniplayer from 'nova-tn-frontend/source/scripts/modules/Miniplayer';
// import PlaylistPlayer from 'nova-tn-frontend/source/scripts/modules/PlaylistPlayer'
// import TnLive from 'nova-tn-frontend/source/scripts/modules/TnLive';
// import TnLiveSmall from 'nova-tn-frontend/source/scripts/modules/TnLiveSmall';
import TnLiveHP from 'nova-tn-frontend/source/scripts/modules/TnLiveHP'
import ImageChecker from 'nova-tn-frontend/source/scripts/modules/ImageChecker'
import ReadMore from 'nova-tn-frontend/source/scripts/modules/ReadMore'
// import StreamDetektor from 'nova-tn-frontend/source/scripts/modules/StreamDetektor';
import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'
import VideoPreviews from 'nova-tn-frontend/source/scripts/modules/VideoPreviews'
import StickyPlayer from './modules/StickyPlayer'

import Banner from 'nova-tn-frontend/source/scripts/modules/Banner'
// import Election from 'nova-tn-frontend/source/scripts/modules/Election';
import Copifier from 'nova-tn-frontend/source/scripts/modules/Copifier'
import Minuta from 'nova-tn-frontend/source/scripts/modules/Minuta'
import FootNav from 'nova-tn-frontend/source/scripts/modules/FootNav'
// import MiniplayerVue from 'nova-tn-frontend/source/scripts/modules/miniplayer/main'
//import Disclosures from 'nova-tn-frontend/source/scripts/modules/Disclosures';
// import NewsletterPopUp from 'nova-tn-frontend/source/scripts/modules/NewsletterPopUp';
// import SkiResorts from 'nova-tn-frontend/source/scripts/modules/skiResorts/main';
import ArticleEvents from 'nova-tn-frontend/source/scripts/modules/ArticleEvents'
import PlayerSpecials from 'nova-tn-frontend/source/scripts/modules/PlayerSpecials'
import PlayerGeneral from 'nova-tn-frontend/source/scripts/modules/PlayerGeneral'
// import GreenWeek from 'nova-tn-frontend/source/scripts/modules/GreenWeek';
import BannerOverflowCorrector from 'nova-tn-frontend/source/scripts/modules/BannerOverflowCorrector'
window.Vue = Vue

window.axios = axios
import Iframes from './modules/Iframes'

import NavigationExpand from './modules/NavigationExpand'

import GadgetLoad from './modules/gadgetLoad'
import ShareSocial from './modules/ShareSocial'
import Themes from './modules/Themes'
// import Miniplayer from './modules/Miniplayer';
import HeroMediaInit from './modules/HeroMediaInit'
import PlaylistPlayer from './modules/PlaylistPlayer'
import MiniplayerVue from './modules/miniplayer'
import PlaylistEvents from './modules/playlistEvents'
import CollapseItem from './modules/euro24/SmartCollapseItem'
import GoogleNewsPopUp from './modules/GoogleNewsPopUp'
import SmoothScrollbar from './modules/TvnSmoothScrollbar'
import PagerPluginLimitation from './modules/PagerPluginLimitation'
// ---------------------------------------
// Initialization
// ---------------------------------------

$(function () {
	Navigation.Init()
	Stickies.Init()
	JScroll.Init()
	Search.Init()
	Share.Init()
	MiniplayerVue.Init()
	// PlaylistPlayer.Init()
	// GreenWeek.Init();
	// TnLive.Init();
	// TnLiveSmall.Init();
	TnLiveHP.Init()
	ImageChecker.Init()
	ReadMore.Init()
	Iframes.Init()
	// StreamDetektor.Init();
	VideoPreviews.Init()
	StickyPlayer.Init()
	Banner.Init()
	// Election.Init();
	Copifier.Init()
	Minuta.Init()
	FootNav.Init()
	// Disclosures.Init();
	Themes.Init()
	// NewsletterPopUp.Init();
	// SkiResorts.Init();
	ArticleEvents.Init()
	PlayerSpecials.Init()

	HeroMediaInit.Init()
	NavigationExpand.NavigationExpand()
	ShareSocial.Init()
	GadgetLoad.Init()
	PlayerGeneral.Init()
	BannerOverflowCorrector.Init()
	PlaylistEvents.Init()
	CollapseItem.Init()
	GoogleNewsPopUp.Init()
	SmoothScrollbar.init()
	PagerPluginLimitation.Init()
	window.addEventListener('cookieConsentSet', function (e) {
		PlaylistPlayer.Init(e.detail.purpose)
	})
})
